// extracted by mini-css-extract-plugin
module.exports = {"imgBlank":"_1filBSlKx0J4sLfs2roh3L","downloadBtnWrapper":"_2xwJ0XwzbCGH5KQHdxfWPU"};